import React from 'react';
import Layout from '../components/Layout';
import CareerForm from '../components/CareerForm';

const CreateCareer: React.FC = () => {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <CareerForm mode="create" />
      </div>
    </Layout>
  );
};

export default CreateCareer; 